var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetitionTrackingConfigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.625 14.625C1.625 7.44529 7.44529 1.625 14.625 1.625H37.375C44.5547 1.625 50.375 7.44529 50.375 14.625V37.375C50.375 44.5547 44.5547 50.375 37.375 50.375H14.625C7.44529 50.375 1.625 44.5547 1.625 37.375V14.625ZM21.2063 16.9C20.8994 16.4908 20.4177 16.25 19.9062 16.25C19.3948 16.25 18.9131 16.4908 18.6062 16.9L13 24.375H9.75C8.85251 24.375 8.125 25.1025 8.125 26C8.125 26.8975 8.85251 27.625 9.75 27.625H13.8125C14.324 27.625 14.8056 27.3842 15.1125 26.975L19.9062 20.5833L30.7938 35.1C31.1006 35.5092 31.5823 35.75 32.0938 35.75C32.6052 35.75 33.0869 35.5092 33.3937 35.1L39 27.625H42.25C43.1475 27.625 43.875 26.8975 43.875 26C43.875 25.1025 43.1475 24.375 42.25 24.375H38.1875C37.676 24.375 37.1944 24.6158 36.8875 25.025L32.0938 31.4167L21.2063 16.9Z",
    fill: "#F66127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionTrackingConfigLogo);
export default __webpack_public_path__ + "static/media/competitionTrackingConfigLogo.33f87a36fa8fb6b134d509f1f9b2ef8c.svg";
export { ForwardRef as ReactComponent };